import { BaseGraphQL } from "~/services/baseGraphQL";
import { GRAPHQL_AUTHENTICATION } from "~/constants/url";
import { JsonResponseType } from "~/types/jsonResponseType";
import { UpdateExpiredPasswordInput } from "../types/updateExpiredPassword";

const authenticationGraph = BaseGraphQL({
  baseUrl: GRAPHQL_AUTHENTICATION,
});

export const updateExpiredPassword = async (
  input: UpdateExpiredPasswordInput,
) => {
  const query = `
        query updateExpiredPassword(
      $username: String!
      $password: String!
      $newPassword: String!
    ) {
      authenticate {
        updateExpiredPassword(
          changePasswordVM: {
            username: $username
            password: $password
            newPassword: $newPassword
          }
        ) {
          succeed
          messageCode
        }
      }
    }
  `;

  return await authenticationGraph<
    { succeed: boolean; messageCode: string },
    {
      authenticate: {
        updateExpiredPassword: JsonResponseType<{
          succeed: boolean;
          messageCode: string;
        }>;
      };
    }
  >(
    {
      action: "UserGraphQL",
      query,
      variables: { ...input },
    },
    (input) => input.authenticate.updateExpiredPassword,
  );
};
